var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakout-leave-container"},[_c('div',{staticClass:"breakout-leave-btn",on:{"click":_vm.onLeaveClick}},[_c('Icon',{attrs:{"value":"leave-breakout","height":"0.7rem","width":"0.7rem","color":"white"}}),_c('span',{staticClass:"leave-room-txt"},[_vm._v("Leave Breakout Room")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }